import axios from "axios";
import { apiConfig } from "../../config";

interface MemberPayload {
  name: string;
  email: string;
  userId?: string;
}

class MemberBillingClient {
  private auth0Client: any;

  constructor(auth0Client: any) {
    this.auth0Client = auth0Client;
  }

  private async getAuthHeaders() {
    const token = await this.auth0Client.getTokenSilently();
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async addMember(orgId: string, member: MemberPayload): Promise<any> {
    const headers = await this.getAuthHeaders();
    const response = await axios.post(
      `${apiConfig.providerServiceBase}/subscription/v2/api/subscriptions/org/${orgId}/members`,
      member,
      { headers }
    );
    return response.data; // expected { member, invoice }
  }
}

export default MemberBillingClient;